/**
 * Maps the ui-kit {@code AddressService.parseJsonAddressData} output onto the
 * CS-823 admin API request shape.
 *
 * The shared parser produces the retailer/portal snake_case shape: it sets
 * {@code address.formatted_address} and {@code addressPlace.place_id} but leaves
 * the camelCase {@code formattedAddress}/{@code placeId} at their empty defaults.
 * The admin address/place DTOs read the camelCase names and require them, so a
 * raw parser payload fails validation. Remap the differently-named required
 * fields here; the parser's already-camelCase geographic fields (locality,
 * countryCode, administrativeAreaLevel1, …) pass through untouched.
 */
export interface AdminAddressPayload {
  address: any;
  addressPlace: any;
}

export function toAdminAddress(parsed: {address: any; addressPlace: any}): AdminAddressPayload {
  const a = parsed?.address ?? {};
  const p = parsed?.addressPlace ?? {};
  return {
    address: {
      ...a,
      formattedAddress: a.formatted_address ?? a.formattedAddress ?? '',
      mapsUrl: a.maps_url ?? a.mapsUrl ?? '',
    },
    addressPlace: {
      placeId: p.place_id ?? p.placeId ?? '',
      place: p.place,
    },
  };
}
